import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  flex: 1,
  width: "100%",
  height: "100%",
  backgroundColor: "#252327",
}));

export const Card = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  width: 420,
  padding: theme.spacing(4),
  margin: "auto",
  borderRadius: 20,
  border: "2px dashed white",
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textTransform: "uppercase",
  textAlign: "center",
  lineHeight: "32px",
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textAlign: "center",
  opacity: 0.8,
}));
